@if (resultsCount() > 0) {
  <div data-automation="search-result-section-users" class="search-result-section mb-4">
    <h4 data-automation="search-result-header" class="search-result-section--header mb-2">
      <strong>{{ heading() | translate }} ({{ resultsCount() }})</strong>
    </h4>
    <ng-content></ng-content>
  </div>
}
